export const BULK_SEND_BATCH_SIZE = 100;
